export default function Footer() {
  return (
    <footer>
      체크가드㈜ Seoul, Republic of Korea Toegye-ro 30-gil 15-8,302 The Future
      Of Safety{" "}
    </footer>
  );
}
